import { gql, useQuery } from '@apollo/client'

import {
  PrepaidPointBoxFragmentDoc,
  PrepaidPointOrdersQuery,
  PrepaidPointOrdersQueryVariables,
} from '@/clients/utoniq-core/schema'
import { makeViewModel } from '@/core/architecture'

import { Action, State } from './template'

export const useViewModel = makeViewModel<State, Action>(() => {
  const { data, loading, fetchMore } = useQuery<
    PrepaidPointOrdersQuery,
    PrepaidPointOrdersQueryVariables
  >(QUERY)

  return {
    state: {
      loading,
      hasNextPage: !!data?.prepaidPointTransactions?.pageInfo.hasNextPage,
      prepaidPointTransactions: data?.prepaidPointTransactions ?? null,
    },
    actions: {
      async onFetchMore() {
        await fetchMore({
          variables: {
            pageInput: {
              cursor: data?.prepaidPointTransactions?.pageInfo.endCursor,
            },
          },
        })
      },
    },
  }
})

export const QUERY = gql`
  query PrepaidPointOrders($pageInput: PageInput) {
    prepaidPointTransactions(pageInput: $pageInput) {
      edges {
        node {
          ...PrepaidPointBox
        }
      }
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
  ${PrepaidPointBoxFragmentDoc}
`
